var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStakedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 22.25,
    viewBox: "0 0 21.5 22.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Staking",
    transform: "translate(88.71 -547.811) rotate(90)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M28.9,27.816c.23-3.782,1.605-5.326,4.614-5.326h.1c3.321,0,4.652,1.88,4.652,6.576v6.849c0,4.7-1.33,6.576-4.652,6.576h-.1c-2.987,0-4.362-1.523-4.607-5.242",
    transform: "translate(531.047 45.47)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    transform: "translate(549.311 73.46)",
    fill: "none",
    stroke: "#ff6a42",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M2.587,4.833a.678.678,0,0,0-.169-.484,1.528,1.528,0,0,0-.573-.332,6.755,6.755,0,0,1-.7-.3,2.22,2.22,0,0,1-.5-.345,1.385,1.385,0,0,1-.326-.458A1.536,1.536,0,0,1,.2,2.287,1.39,1.39,0,0,1,.6,1.26,1.689,1.689,0,0,1,1.668.793V0h.593V.8a1.548,1.548,0,0,1,1.027.547,1.8,1.8,0,0,1,.371,1.177H2.587A1.023,1.023,0,0,0,2.4,1.862a.606.606,0,0,0-.491-.221.625.625,0,0,0-.471.172.656.656,0,0,0-.167.476.627.627,0,0,0,.163.452,1.8,1.8,0,0,0,.606.348,6.73,6.73,0,0,1,.728.335,2.1,2.1,0,0,1,.482.356,1.378,1.378,0,0,1,.3.452,1.554,1.554,0,0,1,.1.591,1.384,1.384,0,0,1-.393,1.023,1.723,1.723,0,0,1-1.082.463v.737H1.594V6.315A1.783,1.783,0,0,1,.417,5.776,1.738,1.738,0,0,1,0,4.558H1.071a.985.985,0,0,0,.209.676.764.764,0,0,0,.6.235A.736.736,0,0,0,2.4,5.3.6.6,0,0,0,2.587,4.833Z",
    transform: "translate(550.348 79.789) rotate(-90)",
    fill: "#ff6a42"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    y1: 7,
    transform: "translate(562.875 74.459)",
    fill: "none",
    stroke: "#ff6a42",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakedIc);
export default __webpack_public_path__ + "static/media/staked-ic.e4bf597eef13fc243978d31dd31c7c0e.svg";
export { ForwardRef as ReactComponent };